module.exports = __webpack_public_path__ + "img/main_logo.130b9c91.png";